export type PresetKey = '1h' | '6h' | '24h' | 'today' | 'yday' | '7d' | '30d';

/** Every preset, in the order the period picker lists them. */
export const presets: PresetKey[] = ['1h', '6h', '24h', 'today', 'yday', '7d', '30d'];

/** The presets shown as buttons next to the period picker. */
export const quickPresets: PresetKey[] = ['24h', '7d', '30d'];

/** A time window [from, to) and the preset it came from, or `custom` when picked by hand. */
export interface Period {
  preset: PresetKey | 'custom';
  from: Date;
  to: Date;
}

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/** The window a preset covers when picked at `now`; days start at local midnight. */
export const presetPeriod = (preset: PresetKey, now: Date = new Date()): Period => {
  const end = now.getTime();
  const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const back = (ms: number) => ({ preset, from: new Date(end - ms), to: new Date(end) });
  switch (preset) {
    case '1h':
      return back(HOUR);
    case '6h':
      return back(6 * HOUR);
    case '7d':
      return back(7 * DAY);
    case '30d':
      return back(30 * DAY);
    case 'today':
      return { preset, from: midnight, to: new Date(end) };
    case 'yday': {
      const yesterday = new Date(midnight.getFullYear(), midnight.getMonth(), midnight.getDate() - 1);
      // Ends on the last millisecond of yesterday, which reads as 23:59.
      return { preset, from: yesterday, to: new Date(midnight.getTime() - 1) };
    }
    default:
      return back(DAY);
  }
};
